/* table-head.tsx generated by @compiled/babel-plugin v0.36.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isRanking", "testId"],
  _excluded2 = ["width", "children", "isSortable", "sortOrder", "isFixedSize", "shouldTruncate", "onClick", "style", "testId"];
import "./table-head.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable @repo/internal/react/require-jsdoc */

import { forwardRef } from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { B100, N300, N30A, N40 } from '@atlaskit/theme/colors';
import { ASC, DESC } from '../internal/constants';
import { getTruncationStyleVars } from './constants';
var CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
var rankingStyles = null;
var headStyles = null;
var overflowTruncateStyles = null;
var truncationWidthStyles = null;
var fixedSizeTruncateStyles = null;
var cellStyles = null;
export var Head = function Head(_ref) {
  var isRanking = _ref.isRanking,
    testId = _ref.testId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("thead", _extends({
    "data-testid": testId
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
  }, props, {
    className: ax(["_179rglyw", isRanking && "_1e0c1ule"])
  }));
};
var headCellBaseStyles = null;
var headCellBaseStylesOld = null;
var onClickStyles = null;
var baseStyles = null;
var ascendingStyles = null;
var descendingStyles = null;
export var HeadCell = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var width = _ref2.width,
    children = _ref2.children,
    isSortable = _ref2.isSortable,
    sortOrder = _ref2.sortOrder,
    isFixedSize = _ref2.isFixedSize,
    shouldTruncate = _ref2.shouldTruncate,
    onClick = _ref2.onClick,
    style = _ref2.style,
    testId = _ref2.testId,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  var mergedStyles = _objectSpread(_objectSpread(_objectSpread({}, style), width && getTruncationStyleVars({
    width: width
  })), {}, _defineProperty({}, CSS_VAR_TEXT_COLOR, "var(--ds-text-subtlest, ".concat(N300, ")")));
  var isASC = sortOrder === ASC;
  var isDESC = sortOrder === DESC;
  var getFormattedSortOrder = function getFormattedSortOrder() {
    if (isASC) {
      return 'ascending';
    } else if (isDESC) {
      return 'descending';
    }
  };

  // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
  // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
  var Component = children ? 'th' : 'td';
  var isVisuallyRefreshed = fg('platform-component-visual-refresh');
  return /*#__PURE__*/React.createElement(Component, _extends({
    "aria-sort": getFormattedSortOrder()
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ,

    onClick: !isVisuallyRefreshed ? onClick : undefined,
    ref: ref,
    "data-testid": testId
  }, rest, {
    className: ax(["_izbqglyw _h7alglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t", isVisuallyRefreshed ? "_11c8dcr7 _179rralu _mqm2glyw _kqswh2mm _syaz12fi _k48pmoej _y3gn1e5h _s7n4nkob _1ygbuwsq" : "_11c8dcr7 _179rralu _mqm2glyw _t51zglyw _191wglyw _vchhusvi _kqswh2mm _syaz12fi _k48pmoej _y3gn1e5h _s7n4jp4b _1ygbuwsq", !isVisuallyRefreshed && onClick && "_irr3bfnf _d0altlke", "_1bsb8a2a", isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c", isFixedSize && "_1reo15vq _18m915vq", !isVisuallyRefreshed && isSortable && "_173zglyw _pw6dglyw _1xgk1j28 _1wfn1j28 _y9yonqa1 _997wnqa1 _sklb1l7b _1j091l7b _19w61ule _1w611ule _1hvvidpf _n56nidpf _wyc4idpf _1d4oidpf _no7mstnw _qh32stnw _4b5mb3bt _hn3bb3bt _14gsx0bf _cigmx0bf _c77k1f6e _qzvtu2gc _f4731f6e _1fpyidpf _a04fh2mm _xv14glyw _58ej1kw7 _1ay31kw7 _mdbq1kw7 _10pp1kw7 _1yw3ze3t _n2fdze3t _8607ze3t _szhwze3t _1g2wwc43 _ze9fwc43 _1lcgnqa1 _at5qnqa1 _o4d71l7b _npl51l7b _1rp11onz _1iornqa1 _oi051l7b _1ehx1onz _19t8nqa1 _1bog1l7b", !isVisuallyRefreshed && isASC && "_c77k2wk4 _142s94yt", !isVisuallyRefreshed && isDESC && "_f4732wk4 _17x894yt"]),
    style: _objectSpread(_objectSpread({}, mergedStyles), {}, {
      "--_k02y3n": ix("2px solid ".concat("var(--ds-border, ".concat(N40, ")"))),
      "--_17ckjys": ix("var(--ds-text-subtle, ".concat("var(".concat(CSS_VAR_TEXT_COLOR, ")"), ")")),
      "--_jz8ahf": ix("solid 2px ".concat("var(--ds-border-focused, ".concat(B100, ")"))),
      "--_6j4ewu": ix("var(--ds-background-neutral-hovered, ".concat(N30A, ")")),
      "--_1rdacuj": ix("3px solid ".concat("var(--ds-icon-disabled, ".concat(N40, ")"))),
      "--_1qca9zt": ix("3px solid ".concat("var(--ds-icon-subtle, ".concat(N300, ")")))
    })
  }), children);
});